<template>
    <div class="col-md-4 col-sm-12">
    <div class="search-result-row">
        <div class="search-result-img">
            <div class="search-result-left img-scale-in">
                <a :href="$store.state.hrefPrefix + '/articles/' + article.slug"><img v-if="article.blob" :src="article.blob.url" alt=""/></a>
            </div>
            <div class="search-result-right">
                <h2><a :href="$store.state.hrefPrefix + '/category/' + article.category.slug">{{ article.category.category_languages[0].pivot.name }}</a></h2>
                <h3><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{ article.article_languages[0].pivot.title }}</a></h3>
            </div>
        </div>
        <p>{{ article.article_languages[0].pivot.description }}</p>
        <ul>
            <li v-if="article.second_author == null">{{ $t('by') }} <strong>{{ article.author.author_languages[0].pivot.name }}</strong></li>
            <li v-else>{{ $t('by') }} <strong>{{ article.author.author_languages[0].pivot.name }}</strong> & <strong>{{ article.second_author.author_languages[0].pivot.name }}</strong></li>
            <li>{{ formattedCreatedAt }}</li>
        </ul>
    </div>
    </div>
</template>

<script>
export default {
    name: "SelectedColumnArticle",
    props: {
        article: {
            type: Array,
            default: []
        }
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date((this.article.published_at ?? this.article.created_at).replace(' ', 'T'));
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            let locale = 'en-US';
            switch (this.$store.state.language.code) {
                case 'ar':
                    locale = 'ar-LB';
                    break;
                case 'tr':
                    locale = 'tr-TR';
                    break;
            }
            return date.toLocaleDateString(locale, options).toUpperCase();
        }
    }
}
</script>

<style scoped>

</style>
